/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ actor: NonNullable<unknown>, permission: NonNullable<unknown>, count: NonNullable<unknown> }} Notification_Project_Access_Granted_ManyInputs */



/**
* | output |
* | --- |
* | "{actor} gave you {permission} access to {count} projects" |
*
* @param {Notification_Project_Access_Granted_ManyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_project_access_granted_many = /** @type {((inputs: Notification_Project_Access_Granted_ManyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Project_Access_Granted_ManyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.actor} hat Ihnen ${i?.permission}zugriff auf ${i?.count} Projekte gegeben`)
	return /** @type {LocalizedString} */ (`${i?.actor} gave you ${i?.permission} access to ${i?.count} projects`)
});